import React from 'react';
import { bool, shape, string } from 'prop-types';

const StatusInProgress = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.00004 0.583374V2.33337C9.57837 2.33337 11.6667 4.42171 11.6667 7.00004C11.6667 7.91587 11.3984 8.76754 10.9434 9.48504L10.0917 8.63337C10.3542 8.14921 10.5 7.58921 10.5 7.00004C10.5 5.06921 8.93087 3.50004 7.00004 3.50004V5.25004L4.66671 2.91671L7.00004 0.583374ZM3.50004 6.99904C3.50004 8.92987 5.06921 10.499 7.00004 10.499V8.74904L9.33337 11.0824L7.00004 13.4157V11.6657C4.42171 11.6657 2.33337 9.57737 2.33337 6.99904C2.33337 6.08321 2.60171 5.23154 3.05671 4.51404L3.90837 5.36571C3.64587 5.84987 3.50004 6.40987 3.50004 6.99904Z" fill="currentColor" />
  </svg>
);

StatusInProgress.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default StatusInProgress;
